import { queries } from "lib/build/dashboards/shared";

import { useLastEventValueByQuery } from "src/features/events";

export function usePhoneNumber(): string | undefined {
	const value = useLastEventValueByQuery<string[]>(queries.phoneNumber);
	return value === undefined || value.length === 0 ? undefined : value[0];
}
